import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import styles from 'styles/components/header.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getAuthShopRef, getIsAdmin, getStoreRef } from 'reducks/auth/selectors'
import { useQueryStoreName } from 'hooks/store'
import { SubHeaderBackground, SubHeaderNavMenu } from 'components/SubHeader'
import { getSubHeaderOpen } from 'reducks/nav/selectors'
import { toggleSubHeader } from 'reducks/nav/operations'
import { useIsAdminNotViewingStore } from 'hooks/auth'
import { MELLOW_SHOP_ID } from 'constants/shop'
import { FirebaseDocRefType } from 'firebase/index'

const SubHeader: FC = React.memo(() => {
  const dispatch = useDispatch()
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const open = useSelector((state: State) => getSubHeaderOpen(state))
  const shopRef: FirebaseDocRefType | undefined = useSelector((state: State) => getAuthShopRef(state))
  const storeRef: FirebaseDocRefType | undefined = useSelector((state: State) => getStoreRef(state))
  const currentStoreName = useQueryStoreName(storeRef)
  const isAdminNotViewingStore = useIsAdminNotViewingStore(isAdmin, storeRef, shopRef)
  const toggle = useCallback(() => dispatch(toggleSubHeader()), [dispatch])

  const subHeaderInnerRef = React.createRef<HTMLDivElement>()
  const [subHeaderInnerHeight, setSubHeaderInnerHeight] = useState<number>(0)

  const label = useMemo(() => {
    if (isAdminNotViewingStore) {
      return 'スーパー管理者で操作中'
    } else if (shopRef?.id === MELLOW_SHOP_ID) {
      // TODO 店舗横断モードを共通化する際に変更する
      return `Marché Bakery スタッフで操作中`
    } else {
      return `${currentStoreName}で操作中`
    }
  }, [isAdminNotViewingStore, currentStoreName, shopRef])

  useEffect(() => {
    const elm = subHeaderInnerRef.current
    if (!elm) return
    setSubHeaderInnerHeight(elm.clientHeight)
  }, [subHeaderInnerRef])

  // Zendeskのサポートボタンをサブヘッダーの裏側に隠す
  useEffect(() => {
    const launcher = document.getElementById('launcher')
    if (!launcher) return
    if (open) {
      launcher.classList.add(styles.subheader__zendesk)
    } else {
      launcher.classList.remove(styles.subheader__zendesk)
    }
  }, [open])

  return (
    <div className={open ? `${styles.subheader} ${styles.open}` : styles.subheader}>
      <div className={styles.subheader__inner} onClick={toggle} ref={subHeaderInnerRef}>
        <span className={styles.subheader__label}>{label}</span>
        <Spacer size={8} />
        <span className={styles.subheader__arrow} />
      </div>
      <SubHeaderNavMenu subHeaderInnerHeight={subHeaderInnerHeight} />
      <SubHeaderBackground open={open} toggle={toggle} />
    </div>
  )
})

export default SubHeader
